<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZljoiC/tc-custom/9780226201351.jpg?1733029295851" alt="This image is the cover for the book Closed Circuits"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Closed Circuits
      </h1>
      <p class="bookDescription body article font2">
        <p>The recent uproar over NSA dataveillance can obscure the fact that surveillance has been part of our lives for decades. And cinema has long been aware of its power—and potential for abuse.<br/><br/> In <i>Closed Circuits</i>, Garrett Stewart analyzes a broad spectrum of films, from <i>M</i> and <i>Rear Window</i> through <i>The Conversation</i> to <i>Déjà Vu</i>, <i>Source Code</i>, and <i>The Bourne Legacy</i>, in which cinema has articulated—and performed—the drama of inspection’s unreturned look. While mainstays of the thriller, both the act and the technology of surveillance, Stewart argues, speak to something more foundational in the very work of cinema. The shared axis of montage and espionage—with editing designed to draw us in and make us forget the omnipresence of the narrative camera—extends to larger questions about the politics of an oversight regime that is increasingly remote and robotic. To such a global technopticon, one telltale response is a proliferating mode of digitally enhanced “surveillancinema.”<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Garrett Stewart
      </h2>
      
      <p class="authorDescription body article"><B>Garrett Stewart</B> is the James O. Freedman Professor of Letters in the Department of English at the University of Iowa and the author of numerous books on fiction and film.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?86af3c9c